import React, { useState, useEffect } from "react";
import axios from "axios";
import progressGif from "../../images/progress.gif";
import AuaAuthAnalysisExcel from "./AuaAuthAnalysisExcel";

const AuaAuthAnalysis = () => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [showExcel, setShowExcel] = useState(false);
  const [shouldFetchFunctionList, setShouldFetchFunctionList] = useState(false);

  useEffect(() => {
    fetchActiveMonths();
  }, []);

  const fetchActiveMonths = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL}/api/auaAuth/active-months`);
      const activeMonths = Array.isArray(res.data) ? res.data : [];

      const currentDate = new Date();
      const targets = [];
      for (let i = 0; i < 3; i++) {
        const d = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
        targets.push({ month: d.getMonth() + 1, year: d.getFullYear() });
      }

      const monthNames = {
        1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun",
        7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec",
      };

      const optionsList = targets.map((t) => ({
        label: `${monthNames[t.month]} ${t.year}`,
        month: t.month,
        year: t.year,
      }));

      setOptions(optionsList);
      if (optionsList.length > 0) setSelectedOption(optionsList[0]);
    } catch (err) {
      console.error("Error fetching active months:", err);
    }
  };

  const handleGenerate = async () => {
    if (!selectedOption) {
      alert("Please select a month and year first!");
      return;
    }

    setLoading(true);
    setShowExcel(false);
    setMessage({ text: "", type: "" });
    setShouldFetchFunctionList(false);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/auaAuth/generate`,
        {
          params: {
            month: selectedOption.month,
            year: selectedOption.year,
          },
        }
      );

      const responseText = String(response.data || "");
      console.log("Response from backend:", responseText);

      if (responseText.includes("All shops are offline")) {
        setMessage({
          text: "All shops are offline , cannot generate data",
          type: "error"
        });
        setShowExcel(false);
      } 
      else if (responseText.includes("Generating data , Please wait")) {
        setMessage({
          text: "Generating data , Please wait...",
          type: "warning"
        });
        setShowExcel(false);
      }
      else if (responseText.includes("Data already generated for selected Month & Year. Please download Excel.")) {
        setMessage({
          text: "Data generated Successfully for Online shops only, Please download excel",
          type: "info"
        });
        setShowExcel(true);
        setShouldFetchFunctionList(true);
      }
      else if (responseText.includes("Data generated successfully for Online shops only. Please download Excel.")) {
        setMessage({
          text: "Data generated Successfully for Online shops only, Please download excel",
          type: "success"
        });
        setShowExcel(true);
        setShouldFetchFunctionList(true);
      }
      else {
        setMessage({
          text: responseText || "Unknown response from server",
          type: "info"
        });
      }

    } catch (error) {
      console.error("Error generating report:", error);
      setMessage({
        text: "Error generating AUA Auth Analysis",
        type: "error"
      });
      setShowExcel(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

       <br></br>

        <table style={{ width: "40%", borderCollapse: "collapse" }} align="center">
          <tbody>
            <tr className="tableheader">
              <th  colSpan='2'>AUA Auth Analysis</th></tr>
            <tr >
              <td>
                Month & Year
              </td>
              <td >
                <select
                  value={selectedOption?.label || ""}
                  onChange={(e) => {
                    const selected = options.find(
                      (opt) => opt.label === e.target.value
                    );
                    setSelectedOption(selected || null);
                  }}
                  
                >
                  {options.map((opt, index) => (
                    <option key={index} value={opt.label}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </td>
            </tr>

            <tr>
              <td colSpan="2" style={{ padding: "8px 10px", textAlign: "center" }}>
                <button
                  onClick={handleGenerate}
                  disabled={loading}
                  style={{
                    background: loading ? "#666" : "black",
                    color: "white",
                    padding: "6px 12px",
                    border: "none",
                    borderRadius: "10px",
                    fontWeight: "bold",
                    fontSize: "13px",
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                >
                  Generate AUA Auth Analysis
                </button>
              </td>
            </tr>
          </tbody>
        </table>

      {loading && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <img src={progressGif} alt="Loading..." width="250" height="15" />
        </div>
      )}

      {message.text && (
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            fontSize: "20px",
            textDecoration: "underline",
            fontWeight: "bold",
            color: "darkred",
          }}
        >
          {message.text}
        </div>
      )}

      {showExcel && !loading && (
        <AuaAuthAnalysisExcel 
          shouldFetchFunctionList={shouldFetchFunctionList}
        />
      )}
    </>
  );
};

export default AuaAuthAnalysis;

